import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { startAnalytics } from "./analytics";
import ErrorBoundary, { webglAvailable } from "./features/ErrorBoundary";
import "./index.css";

startAnalytics();

const root = createRoot(document.getElementById("root")!);

// MapLibre + deck.gl require WebGL; without this check a locked-down device
// renders a silent black rectangle.
if (!webglAvailable()) {
  root.render(
    <div
      style={{
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
        gap: 10, height: "100vh", background: "#0a0e17", color: "rgba(255,255,255,0.85)",
        font: "400 14px Inter, sans-serif", padding: 24, textAlign: "center",
      }}
    >
      <div style={{ fontSize: 36 }}>🌀</div>
      <b>This app needs WebGL to draw the map.</b>
      <p style={{ color: "rgba(255,255,255,0.55)", maxWidth: 420 }}>
        Your browser or device has WebGL disabled or unavailable. Try a current
        version of Chrome, Edge, Firefox, or Safari with hardware acceleration on.
      </p>
    </div>,
  );
} else {
  root.render(
    <StrictMode>
      <ErrorBoundary label="the app">
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}
